import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'select',
        name: 'ADFilter',
        nextField: 'ADUser',
        title: i18n.t('user.form.ADFilter'),
        rules: {required: true},
        modal: ['filter'],
        data: ['filter'],
        options: {
            data: [],
            label: 'description',
            track: 'id'
        },
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'User',
        },
        checkBox: false
    },
    {
        type: 'grid',
        beforeField: 'ADFilter',
        name: 'ADUser',
        title: i18n.t('user.form.ADUser'),
        rules: {},
        modal: ['username'],
        data: ['sAMAccountName'],
    },
    {
        type: 'radio',
        connectField: 'ADUser',
        name: 'type',
        title: i18n.t('account.panelUsers.userType'),
        rules: {required: true},
        options: {
            type: 'locale',
            data: [
                { text: i18n.t('account.panelUsers.contact'), value: 2 },
                { text: i18n.t('account.panelUsers.user'), value: 1 },
                { text: i18n.t('account.panelUsers.both'), value: 0 },
            ],
        },
        modal: ['type'],
        data: ['user_type'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        connectField: 'type',
        connectFieldValue: [0,1],
        name: 'order',
        title: i18n.t('account.user.order'),
        rules: {required: true, numeric: true},
        options: false,
        modal: ['order_no'],
        data: ['order_no',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        connectField: 'type',
        connectFieldValue: [0,2],
        name: 'priorty',
        title: i18n.t('account.user.priorty'),
        rules: {required: true, numeric: true},
        options: false,
        modal: ['priorty_no'],
        data: ['priorty_no',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        connectField: 'type',
        connectFieldValue: [0,2],
        name: 'task',
        title: i18n.t('account.user.task'),
        rules: {required: true},
        options: {
            data: [],
            label: 'Name',
            track: 'ID'
        },
        modal: ['task_id'],
        data: ['task'],
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'Defination',
        },
        checkBox: false
    },
    {
        type: 'text',
        connectField: 'type',
        connectFieldValue: [0,2],
        name: 'alrPass',
        title: i18n.t('account.user.alrPass'),
        rules: {required: true},
        options: false,
        modal: ['alr_pass'],
        data: ['alr_pass',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        connectField: 'type',
        connectFieldValue: [0,2],
        name: 'pass',
        title: i18n.t('account.user.pass'),
        rules: {required: true},
        options: false,
        modal: ['password'],
        data: ['password',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        connectField: 'type',
        connectFieldValue: [0,1],
        name: 'alarm',
        title: i18n.t('account.user.alarm'),
        rules: {required: true},
        options: {
            type:'locale',
            data: [
                { text: i18n.t('account.user.noAlarms'), value: 0 },
                { text: i18n.t('account.user.armAlarm'), value: 1 },
                { text: i18n.t('account.user.disarmAlarm'), value: 2 },
                { text: i18n.t('account.user.allAlarm'), value: 3 },
            ],
            label: 'text',
            track: 'value'
        },
        modal: ['alarm_type'],
        data: ['alarm_type'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        connectField: 'type',
        connectFieldValue: [0,1],
        name: 'registerNo',
        title: i18n.t('account.user.registerNo'),
        rules: {},
        options: false,
        modal: ['register_no'],
        data: ['register_no'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'radio',
        connectField: 'ADUser',
        name: 'tempUser',
        title: i18n.t('account.panelUsers.termUser'),
        rules: {},
        default: false,
        options: {
            type: 'locale',
            data: [
                {text: i18n.t('general.no'), value: false},
                {text: i18n.t('general.yes'), value: true},
            ],
        },
        modal: ['tempUser'],
        data: ['tempUser'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'date',
        name: 'beginDate',
        format:'YYYY-MM-DDT00:00:00.000Z',
        connectField: 'tempUser',
        connectFieldValue: [true],
        title: i18n.t('account.details.beginDate'),
        rules: {},
        modal: ['begin_time'],
        data: ['begin_time'],
        nextField: 'endDate',
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'date',
        name: 'endDate',
        format:'YYYY-MM-DDT00:00:00.000Z',
        connectField: 'tempUser',
        connectFieldValue: [true],
        title: i18n.t('account.details.endDate'),
        rules: {},
        modal: ['end_time'],
        data: ['end_time'],
        additionalButton: false,
        checkBox: false
    },
    
   
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/PanelUserLDAP.js